import axios from 'axios';
import { apiUrl, applyInterceptors } from './config';

const notificationsApi = axios.create();
applyInterceptors(notificationsApi);

/**
 * Register a push token for the current user
 * @param {string} token - FCM Token
 * @param {string} deviceType - 'android', 'ios', or 'web'
 * @param {string} fingerprint - Unique device identifier
 */
export const registerPushToken = (token, deviceType, fingerprint) => {
  return notificationsApi.post(apiUrl('users/push-token/'), {
    token,
    device_type: deviceType,
    fingerprint
  });
};

/**
 * De-register a push token (on logout)
 * @param {string} token - FCM Token to remove
 */
export const deregisterPushToken = (token) => {
  return notificationsApi.delete(apiUrl('users/push-token/'), {
    data: { token },
    timeout: 1500,
    skipAuthRefresh: true
  });
};

/**
 * Get count of unread notifications for the user
 */
export const getUnreadCount = () => {
  return notificationsApi.get(apiUrl('users/notifications/unread-count/'));
};

/**
 * Fetch notification history for the user
 */
export const getNotifications = (params = {}) => {
  return notificationsApi.get(apiUrl('users/notifications/'), { params });
};

/**
 * Mark a single notification as read
 */
export const markAsRead = (id) => {
  return notificationsApi.post(apiUrl(`users/notifications/${id}/mark-read/`));
};

/**
 * Mark all notifications as read for the user
 */
export const markAllAsRead = () => {
  return notificationsApi.post(apiUrl('users/notifications/mark-all-read/'));
};

/**
 * Report delivery or read receipt for a tuition FCM notification
 * @param {number|string} fcmLogId
 * @param {'delivered'|'read'} event
 * @param {string} platform - 'web', 'ios', 'android'
 */
export const reportFCMReceipt = (fcmLogId, event, platform = 'web') => {
  if (!fcmLogId || !event) return Promise.resolve();
  return notificationsApi.post(apiUrl('fcm-notifications/receipt/'), {
    fcm_log_id: parseInt(fcmLogId),
    event,
    platform
  }).catch((e) => console.warn('[reportFCMReceipt] Failed to send receipt:', e));
};


/**
 * Soft delete a notification from the user's inbox
 */
export const deleteNotification = (id) => {
  return notificationsApi.delete(apiUrl(`users/notifications/${id}/`));
};

/**
 * Hard delete all notifications for the user
 */
export const deleteAllNotifications = () => {
  return notificationsApi.post(apiUrl('users/notifications/delete-all/'));
};

const notificationsAPI = {
  registerPushToken,
  deregisterPushToken,
  getUnreadCount,
  getNotifications,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  deleteAllNotifications
};

export default notificationsAPI;
